import script from "./batchSaleStatus.vue?vue&type=script&setup=true&lang=js"
export * from "./batchSaleStatus.vue?vue&type=script&setup=true&lang=js"

import "./batchSaleStatus.vue?vue&type=style&index=0&id=60491ed8&scoped=true&lang=css"

import exportComponent from "/Users/lock/vuework/yaojing-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60491ed8"]])

export default __exports__